import React, { useState, useEffect, useRef } from 'react';

const Distributors = () => {


  useEffect(() => {
  (function(d, w, c) {
    w.ChatraID = 'XsYGMCQ4ANZregsLE';
    var s = d.createElement('script');
    w[c] = w[c] || function() {
      (w[c].q = w[c].q || []).push(arguments);
    };
    s.async = true;
    s.src = 'https://call.chatra.io/chatra.js';
    if (d.head) d.head.appendChild(s);
  })(document, window, 'Chatra');
}, []);

  const [zipCode, setZipCode] = useState('');
  const [showMap, setShowMap] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const mapRef = useRef(null);
  const mapInstance = useRef(null);

  // Load Leaflet dynamically
  useEffect(() => {
    if (showMap && !window.L) {
      // Load Leaflet CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);

      // Load Leaflet JS
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = () => {
        initializeMap();
      };
      document.head.appendChild(script);
    } else if (showMap && window.L) {
      initializeMap();
    }
  }, [showMap, zipCode]);

  const initializeMap = async () => {
    if (!mapRef.current || !window.L) return;

    // Clear existing map
    if (mapInstance.current) {
      mapInstance.current.remove();
    }

    try {
      setIsLoading(true);
      
      // Get coordinates for ZIP code (simple geocoding)
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&postalcode=${zipCode}&limit=1`);
      const data = await response.json();
      
      let lat = 39.8283; // Default to center of US
      let lng = -98.5795;
      
      if (data && data.length > 0) {
        lat = parseFloat(data[0].lat);
        lng = parseFloat(data[0].lon);
      }

      // Initialize map
      mapInstance.current = window.L.map(mapRef.current).setView([lat, lng], 10);

      // Add tile layer
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
        maxZoom: 18
      }).addTo(mapInstance.current);

      // Add marker for the location
      const marker = window.L.marker([lat, lng]).addTo(mapInstance.current);
      marker.bindPopup(`
        <div style="text-align: center; font-family: 'Inter', sans-serif;">
          <h3 style="margin: 0 0 0.5rem 0; color: #09244f;">📍 ZIP Code: ${zipCode}</h3>
          <p style="margin: 0; color: #6b7280; font-size: 0.9rem;">Distributor locations in this area</p>
        </div>
      `).openPopup();

      // Add some mock distributor markers around the area
      const distributors = [
        { lat: lat + 0.02, lng: lng + 0.03, name: "Authorized Dealer A" },
        { lat: lat - 0.015, lng: lng - 0.025, name: "Service Center B" },
        { lat: lat + 0.01, lng: lng - 0.02, name: "Parts Supplier C" }
      ];

      distributors.forEach((dist, index) => {
        const distMarker = window.L.marker([dist.lat, dist.lng], {
          icon: window.L.divIcon({
            html: '🏢',
            className: 'custom-distributor-marker',
            iconSize: [30, 30],
            iconAnchor: [15, 30]
          })
        }).addTo(mapInstance.current);

        distMarker.bindPopup(`
          <div style="text-align: center; font-family: 'Inter', sans-serif; min-width: 200px;">
            <h4 style="margin: 0 0 0.5rem 0; color: #09244f;">🏢 ${dist.name}</h4>
            <div style="color: #6b7280; font-size: 0.85rem; line-height: 1.4;">
              <p style="margin: 0.25rem 0;">📞 (555) 123-456${index}</p>
              <p style="margin: 0.25rem 0;">📧 contact@dealer${index + 1}.com</p>
              <p style="margin: 0.25rem 0;">🕒 Mon-Fri 8AM-5PM</p>
            </div>
            <div style="margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #e5e7eb;">
              <span style="color: #059669; font-size: 0.8rem; font-weight: 500;">
                ✅ Sales • Service • Parts
              </span>
            </div>
          </div>
        `);
      });

      setIsLoading(false);
    } catch (error) {
      console.error('Error initializing map:', error);
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    if (zipCode.trim()) {
      setShowMap(true);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const goBack = () => {
    setShowMap(false);
    setZipCode('');
    if (mapInstance.current) {
      mapInstance.current.remove();
      mapInstance.current = null;
    }
  };

  return (
    <div className="zip-finder">
      {!showMap ? (
        // Initial View
        <div className="initial-view">
          <h1>Find Your Local Distributor</h1>
          <p>Enter your ZIP code to locate authorized Pentair pump distributors in your area for sales, service, and parts support.</p>
          
          <div className="search-container">
            <input
              type="text"
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter your ZIP code"
              className="zip-input"
              maxLength="10"
            />
            <button 
              onClick={handleSearch}
              disabled={!zipCode.trim()}
              className="search-btn"
            >
              Find Distributors
            </button>
          </div>
        </div>
      ) : (
        // Map View
        <div className="map-view">
          <div className="map-header">
            <button onClick={goBack} className="back-btn">← Back to Search</button>
            <h1>Distributors Near {zipCode}</h1>
          </div>
          
          {isLoading && (
            <div className="loading-overlay">
              <div className="loading-spinner"></div>
              <p>Loading map...</p>
            </div>
          )}
          
          <div className="map-container">
            <div ref={mapRef} className="leaflet-map"></div>
          </div>
        </div>
      )}

      <style jsx>{`
        .zip-finder {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }

        /* Initial View */
        .initial-view {
          background: white;
          border-radius: 12px;
          padding: 4rem 2rem;
          text-align: center;
          max-width: 600px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .initial-view h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #111827;
          margin: 0 0 1rem 0;
        }

        .initial-view p {
          font-size: 1.1rem;
          color: #6b7280;
          margin-bottom: 3rem;
          line-height: 1.6;
        }

        .search-container {
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .zip-input {
          flex: 1;
          min-width: 250px;
          max-width: 300px;
          padding: 1rem;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.2s ease;
          text-align: center;
        }

        .zip-input:focus {
          outline: none;
          border-color: #09244f;
          box-shadow: 0 0 0 3px rgba(9, 36, 79, 0.1);
        }

        .search-btn {
          padding: 1rem 2rem;
          background: #09244f;
          color: white;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .search-btn:hover:not(:disabled) {
          background: #061a3d;
          transform: translateY(-1px);
        }

        .search-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* Map View */
        .map-view {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          width: 100%;
          max-width: 1000px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          position: relative;
        }

        .map-header {
          background: #09244f;
          color: white;
          padding: 1.5rem 2rem;
          position: relative;
          text-align: center;
        }

        .map-header h1 {
          margin: 0;
          font-size: 1.75rem;
          font-weight: 700;
        }

        .back-btn {
          position: absolute;
          left: 2rem;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.9);
          color: #374151;
          border: none;
          padding: 0.75rem 1rem;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .back-btn:hover {
          background: white;
          color: #09244f;
          transform: translateY(-50%) translateY(-1px);
        }

        .map-container {
          height: 500px;
          position: relative;
        }

        .leaflet-map {
          height: 100%;
          width: 100%;
        }

        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #e5e7eb;
          border-top: 3px solid #09244f;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 1rem;
        }

        .loading-overlay p {
          color: #09244f;
          font-weight: 500;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Custom marker styles */
        :global(.custom-distributor-marker) {
          background: none !important;
          border: none !important;
          font-size: 20px;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .zip-finder {
            padding: 1rem;
          }
          
          .initial-view {
            padding: 2rem 1rem;
          }
          
          .initial-view h1 {
            font-size: 2rem;
          }
          
          .search-container {
            flex-direction: column;
            align-items: center;
          }
          
          .zip-input {
            min-width: 100%;
          }
          
          .map-header {
            padding: 1rem;
            padding-left: 4rem;
          }
          
          .map-header h1 {
            font-size: 1.5rem;
          }
          
          .back-btn {
            left: 1rem;
            padding: 0.5rem 0.75rem;
            font-size: 0.875rem;
          }
          
          .map-container {
            height: 400px;
          }
        }
      `}</style>
    </div>
  );
};

export default Distributors;